    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
      <ng-container *ngIf="template"
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ person: dataContext }"
      >                  

          <app-detalle
            *ngIf="blnEsOtraPantalla"
            [strWsURL]=dataContext.url
            [strTipo]=dataContext.Tipo
            [strSYS02TIP]=dataContext.SYS02TIP
            [pantalla]=dataContext.pantalla
            [JSONllavesMantenimiento]=dataContext.JSONllavesMantenimiento></app-detalle>
          <app-dashboard
            *ngIf="blnEsDashboard"
            [strWsURL]=dataContext.url
            [strTipo]=dataContext.Tipo
            [strSYS02TIP]=dataContext.SYS02TIP
            [pantalla]=dataContext.pantalla
            [JSONllavesMantenimiento]=dataContext.JSONllavesMantenimiento></app-dashboard>

         <app-lazy-heavy
            *ngIf="blnEsGantt"
            type="gantt"
            [inputs]="{
              strWsURL: dataContext.url,
              strTipo: dataContext.Tipo,
              strSYS02TIP: dataContext.SYS02TIP,
              pantalla: dataContext.pantalla,
              JSONllavesMantenimiento: dataContext.JSONllavesMantenimiento
            }"></app-lazy-heavy>

            <app-checkout
            *ngIf="blnEsCheckout"
            [strWsURL]=dataContext.url
            [strTipo]=dataContext.Tipo
            [strSYS02TIP]=dataContext.SYS02TIP
            [pantalla]=dataContext.pantalla
            [JSONllavesMantenimiento]=dataContext.JSONllavesMantenimiento
            [tabId]="dataContext.SYS02CON"
            [SYS02CON_PAPA]="dataContext.SYS02CON_PAPA"></app-checkout>

      </ng-container>
    </div>
